import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M12 1.25a6.75 6.75 0 0 0-4.773 1.977c-1.68 1.68-2.105 4.047-2.48 6.127l-.009.053c-.396 2.2-.748 4.09-2.015 5.397l-.015.016A1.75 1.75 0 0 0 4 17.75h16a1.75 1.75 0 0 0 1.278-2.945c-1.267-1.307-1.62-3.197-2.016-5.397l-.01-.055c-.374-2.08-.8-4.447-2.479-6.126A6.75 6.75 0 0 0 12 1.25M8.288 4.288a5.25 5.25 0 0 1 7.424 0c1.305 1.305 1.68 3.194 2.074 5.386l.027.155c.367 2.042.782 4.355 2.377 6.009a.25.25 0 0 1-.053.371.25.25 0 0 1-.137.041H4a.25.25 0 0 1-.189-.413c1.594-1.653 2.009-3.966 2.375-6.008l.028-.156c.394-2.191.769-4.08 2.074-5.385"
      clipRule="evenodd"
    />
    <path d="M10.917 20.625a.75.75 0 1 0-1.299.75 2.75 2.75 0 0 0 4.763 0 .75.75 0 1 0-1.299-.75 1.25 1.25 0 0 1-2.165 0" />
  </>
);

const Bell = Icon('bell', svgContents);

export default Bell;
